export default "__VITE_ASSET__DWUta4vN__"